export enum CountInputKey {
  Min = 'minCount',
  Max = 'maxCount',
}
